import { c as _c } from "react/compiler-runtime";
import type { NexperienceFragment } from '@data-access/lib/gql/experience/documents';
import { ExperienceSubtitle } from '@feat/feat-experience/cards';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { AppExperienceRating } from '../../../_components/app-experience-rating';
import { AppExperienceAmenitySection } from './app-experience-amenity-section';
export function AppExperienceTitle(t0) {
  const $ = _c(18);
  const {
    experience,
    onOpenReviews
  } = t0;
  let t1;
  if ($[0] !== experience.activities || $[1] !== experience.suitableFor) {
    t1 = <AppExperienceAmenitySection activities={experience.activities} suitableFor={experience.suitableFor} />;
    $[0] = experience.activities;
    $[1] = experience.suitableFor;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = shopTestId("ExperienceTitle.title");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== experience.title) {
    t3 = <h1 data-testid={t2} className="font-heading1">{experience.title}</h1>;
    $[4] = experience.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== experience.publicId || $[7] !== onOpenReviews) {
    t4 = <AppExperienceRating publicId={experience.publicId} compactCount={true} size="base" rootClassName="sm:hidden" onClick={onOpenReviews} />;
    $[6] = experience.publicId;
    $[7] = onOpenReviews;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = experience.location?.city;
  let t6;
  if ($[9] !== experience.duration || $[10] !== experience.hasMultipleDurations || $[11] !== t5) {
    t6 = <ExperienceSubtitle duration={experience.duration} hasMultipleDurations={experience.hasMultipleDurations} locationName={t5} />;
    $[9] = experience.duration;
    $[10] = experience.hasMultipleDurations;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t3 || $[15] !== t4 || $[16] !== t6) {
    t7 = <>{t1}{t3}{t4}{t6}</>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}